import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Mail, Clock, ExternalLink, Phone } from 'lucide-react';
import Logo from './Logo';
import { PHONE, PHONE_HREF } from '../contact.config';
import '../styles/footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <>

      <footer className="footer">
        <div className="container">
          {/* Promo strip */}
          <div className="footer-promo">
            <div className="footer-promo-text">
              <span>Free In-Home Consultation</span> — No obligation quote across Adelaide SA
            </div>
            <Link to="/book-online" className="footer-promo-btn">Book Now →</Link>
          </div>

          {/* Main grid */}
          <div className="footer-grid">

            {/* Brand */}
            <div>
              <Logo size="lg" showText={false}/>
              <div className="footer-brand-name">YN Dream Curtains</div>
              <div className="footer-brand-tagline">Excellence and Elegance</div>
              <p className="footer-desc">
                Adelaide's trusted specialists in premium custom curtains, blinds and window furnishings —
                sheer curtains, blockout curtains, roller blinds, plantation shutters,
                and outdoor shutters. Professionally installed across all Adelaide suburbs.
              </p>
              <address style={{ fontStyle:'normal' }}>
                <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:'0.82rem', color:'var(--text-dim)', lineHeight:1.6, display:'block', marginBottom:8 }}>
                  Adelaide SA, Australia<br/>Phone: <a href={PHONE_HREF} style={{ color:'var(--gold)', textDecoration:'none' }}>{PHONE}</a><br/>Email: <a href="mailto:yndreamcurtains@gmail.com" style={{ color:'var(--gold)', textDecoration:'none' }}>yndreamcurtains@gmail.com</a>
                </span>
              </address>
              <div className="footer-social">
                <a href="https://www.facebook.com/share/18cnoLTX4n/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><Facebook size={15}/></a>
                <a href="https://www.instagram.com/yndreamcurtain?igsh=MWJtYXVwMjAyMzBwMw==&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><Instagram size={15}/></a>
                <a href="https://www.tiktok.com/@yndreamcurtain?_r=1&_t=ZS-95iCKQZi0dG" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z"/>
                  </svg>
                </a>
              </div>
              <div className="footer-rating"><span className="stars">★★★★★</span> 5-Star Rated · Adelaide SA</div>
            </div>

            {/* Navigation */}
            <div>
              <div className="footer-col-title">Navigation</div>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/products">Products</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/portfolio">Portfolio</Link></li>
                <li><Link to="/book-online">Book Online</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
              <div style={{marginTop:24}}>
                <div className="footer-col-title">Legal</div>
                <ul className="footer-links">
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/terms">Terms & Conditions</Link></li>
                  <li><Link to="/refund-policy">Refund Policy</Link></li>
                  <li><Link to="/accessibility">Accessibility</Link></li>
                </ul>
              </div>
            </div>

            {/* Products */}
            <div>
              <div className="footer-col-title">Our Products</div>
              <ul className="footer-links">
                <li><Link to="/products/sheer-curtains-adelaide">Sheer Curtains</Link></li>
                <li><Link to="/products/blackout-curtains-adelaide">Blockout Curtains</Link></li>
                <li><Link to="/products/blockout-blinds-adelaide">Roller Blinds</Link></li>
                <li><Link to="/products/plantation-shutters-adelaide">Plantation Shutters</Link></li>
                <li><Link to="/products/outdoor-shutters-adelaide">Outdoor Shutters</Link></li>
                <li><Link to="/products">All Products</Link></li>
              </ul>
              <div style={{marginTop:24}}>
                <div className="footer-col-title">Hours</div>
                {[['Mon – Fri','8am – 6pm'],['Saturday','9am – 4pm'],['Sunday','By Appointment']].map(([d,t])=>(
                  <div className="hours-row" key={d}><span className="d">{d}</span><span className="t">{t}</span></div>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <div className="footer-col-title">Contact Us</div>
              <div className="fc-item">
                <div className="fc-icon"><MapPin size={13}/></div>
                <div><div className="fc-label">Location</div><div className="fc-value">Adelaide SA, Australia<br/>Servicing all suburbs</div></div>
              </div>
              <div className="fc-item">
                <div className="fc-icon"><Phone size={13}/></div>
                <div><div className="fc-label">Phone</div><div className="fc-value"><a href={PHONE_HREF}>{PHONE}</a></div></div>
              </div>
              <div className="fc-item">
                <div className="fc-icon"><Mail size={13}/></div>
                <div><div className="fc-label">Email</div><div className="fc-value"><a href="mailto:yndreamcurtains@gmail.com">yndreamcurtains@gmail.com</a></div></div>
              </div>
              <div className="fc-item">
                <div className="fc-icon"><ExternalLink size={13}/></div>
                <div><div className="fc-label">Website</div><div className="fc-value"><a href="https://yndreamcurtains.com" target="_blank" rel="noopener noreferrer">yndreamcurtains.com</a></div></div>
              </div>
              <div className="fc-item">
                <div className="fc-icon"><Clock size={13}/></div>
                <div><div className="fc-label">Response</div><div className="fc-value">Within 24 hours</div></div>
              </div>
              <Link to="/book-online" className="btn-primary" style={{marginTop:14,fontSize:'0.6rem',padding:'11px 20px',display:'inline-flex'}}>
                Book Free Quote
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{borderTop:'1px solid var(--border-soft)'}}>
          <div className="container">
            <div className="footer-bottom">
              <div className="footer-copy">
                © {year} <span className="footer-company-name">YN Dream Curtains</span> — Excellence and Elegance. Adelaide SA, Australia.
              </div>
              <div className="footer-legal-links">
                <Link to="/privacy-policy">Privacy</Link>
                <Link to="/terms">Terms</Link>
                <Link to="/refund-policy">Refunds</Link>
                <Link to="/accessibility">Accessibility</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
